// extracted by mini-css-extract-plugin
export default {"section":"section__r63uk","bg":"bg__swrNN","title":"title__eXfte","content":"content__V7GZ2","link":"link__COTZi","category-list":"category-list__QEIwD","text-btn":"text-btn__015Ml"};